module.exports = __webpack_public_path__ + "img/icon5.dc644543.png";